export default __webpack_public_path__ + "static/media/header_bg_mobile.2acf9f8c.png";